import { render } from "./ProcurementDashboard.vue?vue&type=template&id=2f14cc6c&scoped=true"
import script from "./ProcurementDashboard.vue?vue&type=script&lang=js"
export * from "./ProcurementDashboard.vue?vue&type=script&lang=js"

import "./ProcurementDashboard.vue?vue&type=style&index=0&id=2f14cc6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f14cc6c"]])

export default __exports__